var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4547 5.14655C14.4487 5.14655 13.5205 4.81328 12.7752 4.25107C11.9203 3.60658 11.3061 2.66118 11.0892 1.57153C11.0355 1.3023 11.0066 1.02447 11.0038 0.739746H8.13011V8.59211L8.12667 12.8932C8.12667 14.0431 7.37785 15.0181 6.33985 15.361C6.0386 15.4605 5.71325 15.5077 5.37448 15.4891C4.94206 15.4653 4.53684 15.3349 4.18465 15.1242C3.43514 14.6759 2.92699 13.8627 2.91321 12.9325C2.89153 11.4786 4.0669 10.2932 5.51977 10.2932C5.80655 10.2932 6.08198 10.34 6.33985 10.4251V8.27882V7.50728C6.06786 7.467 5.79106 7.446 5.51116 7.446C3.92093 7.446 2.43363 8.10702 1.37049 9.29789C0.566938 10.1978 0.0849443 11.346 0.0105796 12.55C-0.086852 14.1316 0.491885 15.6351 1.61424 16.7443C1.77915 16.9072 1.95233 17.0583 2.13342 17.1978C3.09568 17.9383 4.27209 18.3397 5.51116 18.3397C5.79106 18.3397 6.06786 18.3191 6.33985 18.2788C7.49732 18.1074 8.56528 17.5775 9.40808 16.7443C10.4437 15.7208 11.0159 14.3619 11.0221 12.9156L11.0073 6.49269C11.5013 6.87381 12.0415 7.18917 12.6213 7.43395C13.5229 7.81438 14.479 8.00718 15.463 8.00683V5.92015V5.14586C15.4636 5.14655 15.4554 5.14655 15.4547 5.14655Z",
    fill: "#EBE0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.4dc87666d1c7f7600e5aa05e9875a8c6.svg";
export { ForwardRef as ReactComponent };